export const Slugs = {
    positionKey: 'PositionKey',
    positionSymbol: 'position::symbol',
    positionOpenShares: 'position::openShares',
    positionSodPosition: 'position::sodPosition',
    positionBoughtShares: 'position::boughtShares',
    positionSoldShares: 'position::soldShares',
    positionAccountKey: 'position::AccountKey',
    positionAccount: 'position::account',
    positionMarketValue: 'position::marketValue',
    positionOpenOrders: 'position::openOrders',
    positionCbAvgPx: 'position::cbAvgPx',
    positionLabBorrowLimit: 'position::lab::borrowLimit',
    positionLabAveragePrice: 'position::lab::averagePrice',
    // TODO: Have Olexii remove this from DB
    //positionPlatform: 'position::platform',
    orderKey: 'OrderKey',
    orderSymbol: 'order::symbol',
    orderSide: 'order::side',
    orderAccount: 'order::account',
    orderClOrdId: 'order::clOrdId',
    orderOrigClOrdId: 'order::origClOrdId',
    orderDestinationOrderId: 'order::destinationOrderId',
    orderPlatform: 'order::platform',
    orderQuantity: 'order::quantity',
    ordersAccountKey: 'order::AccountKey',
    orderStatus: 'order::status',
    orderTif: 'order::tif',
    orderType: 'order::type',
    orderPrice: 'order::price',
    orderStopPrice: 'order::stopPrice',
    orderExpireTime: 'order::expireTime',
    orderSenderCompId: 'order::senderCompId',
    orderSenderSubId: 'order::senderSubId',
    orderAction: 'order::action',
    executionKey: 'ExecutionKey',
    executionSymbol: 'execution::symbol',
    executionsAccountKey: 'execution::AccountKey',
    symbol: 'symbol',
    symbolChangeClose: 'symbol::changeClose',
    symbolChangeOpen: 'symbol::changeOpen',
    symbolPctChangeClose: 'symbol::pctChangeClose',
    symbolPctChangeOpen: 'symbol::pctChangeOpen',
    symbolTopRank: 'symbol::topRank',
    symbolBottomRank: 'symbol::bottomRank',
    ask: 'symbol::ask',
    bid: 'symbol::bid',
    change: 'symbol::change',
    last: 'symbol::last',
    volume: 'symbol::volume',
    barHigh: 'symbol::bar::high',
    barLow: 'symbol::bar::low',
    barOpen: 'symbol::bar::open',
    barClose: 'symbol::bar::close',
    barVolume: 'symbol::bar::volume',
    barTime: 'symbol::bar::time',
    accountKey: 'AccountKey',
    accountName: 'account::name',
    accountId: 'account::accountId',
    accountFirmId: 'account::firm::id',
    accountFirmName: 'account::firm::name',
    accountFirmShortName: 'account::firm::shortName',
    accountFictitiousName: 'account::fictitiousName',
    accountDisplayName: 'account::displayName',
    accountIsAdmin: 'account::isAdmin',
    accountIsOwner: 'account::isOwner',
    accountIsWriter: 'account::isWriter',
    accountExists: 'account::exists',
    accountTrader: 'account::trader',
    accountPlatform: 'account::platform',
    timestamp: 'timestamp',
    entryTime: 'entryTime',
    exitTime: 'exitTime',
};
//# sourceMappingURL=slugs.js.map